module.exports = __webpack_public_path__ + "static/when-genius-failed-the-rise-and-fall-of-long-term-capital-management-144d6aa8cf1f3485b509ee00e6ec5784.jpg";